<script>
export default {
	name: 'IconSvgHashTag',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 21 25" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.25438 23.4508C5.17279 23.8872 4.79189 24.2035 4.34798 24.2035C3.77001 24.2035 3.33452 23.6779 3.44196 23.11L7.67198 0.751251C7.75442 0.315488 8.13519 0 8.57869 0C9.15718 0 9.59302 0.526152 9.48535 1.09454L8.25804 7.57362C8.25289 7.60081 8.24157 7.62647 8.22497 7.64861C8.20847 7.67061 8.19719 7.69608 8.19199 7.72308L6.58148 16.0911C6.57588 16.1202 6.57876 16.1503 6.58976 16.1778C6.60066 16.205 6.60359 16.2348 6.59819 16.2637L5.25438 23.4508ZM13.3079 23.444C13.2248 23.8845 12.8401 24.2035 12.3919 24.2035C11.8085 24.2035 11.3684 23.6736 11.4757 23.1001L12.7544 16.2609C12.7595 16.2337 12.7708 16.208 12.7874 16.1859C12.8039 16.1639 12.8151 16.1384 12.8203 16.1114L14.4162 7.71604C14.4205 7.69364 14.4198 7.67059 14.4143 7.64847C14.4088 7.62639 14.4081 7.60337 14.4123 7.581L15.706 0.751522C15.7886 0.315578 16.1696 0 16.6133 0C17.1918 0 17.6278 0.525907 17.5207 1.09442L13.3079 23.444ZM19.1674 16.5347C19.0809 16.9753 18.6947 17.293 18.2458 17.293H1.47509C0.883669 17.293 0.439416 16.753 0.553409 16.1727C0.639943 15.7321 1.02613 15.4144 1.47509 15.4144H5.65878C5.686 15.4144 5.71248 15.4232 5.73426 15.4396C5.75603 15.4559 5.78252 15.4647 5.80973 15.4647H13.6861C13.7181 15.4647 13.7495 15.456 13.7769 15.4396C13.8044 15.4231 13.8358 15.4144 13.8678 15.4144H18.2458C18.8372 15.4144 19.2814 15.9544 19.1674 16.5347ZM20.7157 7.85422C20.626 8.29103 20.2415 8.60456 19.7956 8.60456H15.176C15.1441 8.60456 15.1127 8.59586 15.0852 8.5794C15.0578 8.56294 15.0264 8.55424 14.9944 8.55424H7.18267C7.14568 8.55424 7.10919 8.56285 7.0761 8.5794C7.04301 8.59595 7.00652 8.60456 6.96952 8.60456H3.0182C2.42678 8.60456 1.98253 8.06456 2.09653 7.48423C2.18306 7.04369 2.56925 6.72598 3.0182 6.72598H19.7956C20.3903 6.72598 20.8353 7.27167 20.7157 7.85422Z"
				:fill="color" />
		</svg>

	</div>
</template>

<style scoped>

</style>